import React, { useEffect, useState } from "react";
import Input from "../../atoms/Input";
import Button from "../../atoms/Button";
import ReBiddingDialog from "../../molecules/ReBiddingDialog";
import { counterBidPostApi } from "../../../utils/API/counterBidPostApi";
import { useDispatch } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import { taxationAmount } from "../../../utils/API/taxationAmount";

const CounterComponent = ({
  isOpen,
  onCancel,
  onOk,
  onCounterPriceOk,
  selectedRowData,
  selectedColumns,
  counterData,
  bidId,
  onCounterBidSuccess,
}) => {
  const dispatch = useDispatch();
  const [numberOfCredits, setNumberOfCredits] = useState(null);
  const [creditsErrorMsg, setCreditsErrorMsg] = useState("");
  const [pricePerCredit, setPricePerCredit] = useState(null);
  const [priceErrorMsg, setPriceErrorMsg] = useState("");
  const previousNumberOfCredits = counterData?.number_Of_Credits;
  const previousPricePerCredits = counterData?.bidAmount;
  const [loading, setLoading] = useState(false);

  const [amount, setAmount] = useState(0);
  const [gst, setGst] = useState(0);
  const [platformFee, setPlatformFee] = useState(0);
  const [remittance, setRemittance] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  const handleCounterBid = async () => {
    if (numberOfCredits <= 0 || pricePerCredit <= 0) {
      if (numberOfCredits <= 0) {
        setCreditsErrorMsg("Number of credits should be greater than 0");
      }
      if (pricePerCredit <= 0) {
        setPriceErrorMsg("Price per credits should be greater than 0");
      }
    } else {
      try {
        setLoading(true);
        const formData = {
          bidId: bidId,
          counterBidAmount: numberOfCredits,
          counterBidCredits: pricePerCredit,
        };
        const response = await counterBidPostApi(formData, dispatch);
        setNumberOfCredits("");
        setPricePerCredit("");
        setCreditsErrorMsg("");
        setPriceErrorMsg("");
        onCounterPriceOk();
      } catch (error) {
        console.error("Error during counter bid:", error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleCancel = () => {
    setNumberOfCredits("");
    setPricePerCredit("");
    setCreditsErrorMsg("");
    setPriceErrorMsg("");
    onCancel();
  };
  useEffect(() => {
    if (numberOfCredits !== 0 && pricePerCredit !== 0) {
      fetchTaxationData();
    }
  }, [numberOfCredits, pricePerCredit]);

  const fetchTaxationData = async () => {
    try {
      const formData = {
        buyerOrigin: "NAT",
        sellerOrigin: "NAT",
        totalAmount: numberOfCredits * pricePerCredit,
      };
      const amounts = await taxationAmount(formData, dispatch);
      setAmount(formData.totalAmount);
      setGst(amounts.data.data.tax);
      setPlatformFee(amounts.data.data.platform_fee);
      setRemittance(amounts.data.data.remittance);
      const calculatedTotalAmount =
        formData.totalAmount -
        (amounts.data.data.tax +
          amounts.data.data.platform_fee +
          amounts.data.data.remittance);
      setTotalAmount(calculatedTotalAmount);
    } catch (error) {
      toast.error("Error in Fetching Taxes and amounts Balance");
    } finally {
    }
  };
  return (
    <ReBiddingDialog
      open={isOpen}
      onCancel={handleCancel}
      onCounterPriceOk={onCounterPriceOk}
      onOk={onOk}
      selectedRowData={selectedRowData}
      selectedColumns={selectedColumns}
    >
      <div className="pt-5">
        <div className="flex pt-2 text-base pb-2 gap-x-20  ">
          <div className="pl-10 font-bold ">Previous Bid-</div>
          <div className="flex gap-x-32 ">
            <div>No of Credits - {previousNumberOfCredits}</div>
            <div>Price per credit - {previousPricePerCredits}</div>
          </div>
        </div>
        <div className="flex font-bold gap-x-16  pt-2 text-base bg-blue-400  ">
          <div className=" pl-10 pr-4">Counter bid-</div>
          <div className="flex gap-x-20 ">
            <div className="flex">
              <span className="text-base font-bold pr-2 ">
                No of Credits -{" "}
              </span>
              <Input
                type="number"
                variant="secondary"
                className="inline-block text-base w-16"
                value={numberOfCredits}
                placeHolder={0}
                onChange={(e) =>
                  setNumberOfCredits(parseInt(e.target.value, 10))
                }
              />
            </div>
            <div className="flex">
              <span className="text-base font-bold pr-2">
                {" "}
                Price per credit -
              </span>
              <Input
                type="number"
                variant="secondary"
                className="inline-block text-base w-14"
                value={pricePerCredit}
                onChange={(e) => setPricePerCredit(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="flex justify-between mx-8">
          <p className="text-red-500 text-sm ">{creditsErrorMsg}</p>
          <p className="text-red-500 text-sm ">{priceErrorMsg}</p>
        </div>
        <div className=" pl-10 pt-3 text-xs text-gray-400">
          <p className="py-1">Amount = ${amount?.toFixed(2)}</p>
          <p className="pb-1">Taxes(GST) = ${gst?.toFixed(2)}</p>
          <p className="pb-1">Remittance = ${remittance?.toFixed(2)}</p>
          <p className="pb-1">Platform Fee = ${platformFee?.toFixed(2)}</p>
        </div>
        <p className=" pl-10 text-sm">
          Total Fund Earn - ${totalAmount?.toFixed(2)}
        </p>
      </div>
      <div className="flex justify-center gap-5">
        <Button
          varient="primary"
          borderColor="blue"
          className=" w-[7.5rem] h-10 mt-4  mb-7 text-base justify-center text-white font-bold border-none  bg-blue-800 "
          onClick={() => handleCounterBid()}
          disabled={loading}
        >
          <div className="flex justify-center">
            {loading ? <LoadingOutlined /> : "Counter"}
          </div>
        </Button>
      </div>
    </ReBiddingDialog>
  );
};

export default CounterComponent;
